<template>
    <b-container fluid class="mt-3 mt-md-5">
        <b-row class="m-0 p-0">
            <b-col col sm="12" class="m-0 p-0">
                <b-card no-body>
                    <div class="card shadow p-0">
                        <div class="card-header bg-transparent p-0 m-0">
                            <h3 class="float-left ml-3 mt-3">
                                {{ $t('message.edit') + ' ' + $t('message.medicalAdvice') }}
                            </h3>
                            <div class="card-body p-0">
                                <b-container fluid class="p-0">
                                    <section class="m-0 p-0">
                                        <b-form class="mt-4 m-0 p-0">
                                            <b-container fluid class="p-0">
                                                <br>
                                                <b-row class="mt-3">
                                                    <b-col md="12" sm="12">
                                                        <span class="obligatoire">*</span>

                                                        <b-form-group
                                                                id="patient-group"
                                                                :label="$t('message.select')+' '+$tc('message.patients',1)"
                                                                label-for="patient">
                                                            <!-- Options -->
                                                            <select id="patient" v-model="$v.form.patient_id.$model" required class="form-control is-invalid border-light retirerBordure">
                                                                <option v-for="item in mPatients" :value="item.value" :key="item.value+'-patient'">
                                                                    {{ item.text }}
                                                                </option>
                                                            </select>

                                                            <b-form-invalid-feedback v-if="errorshasField('patient_id')">
                                                                {{ getErrorsField('patient_id') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-if="$v.form.patient_id.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col md="12" sm="12">
                                                        <b-form-group
                                                                id="motif-group"
                                                                :label="$tc('message.objectAdvice',1)"
                                                                label-for="motif">
                                                            <b-form-input
                                                                    id="motif"
                                                                    v-model="$v.form.object.$model"
                                                                    :state="$v.form.object.$dirty ? !(errorshasField('object') || $v.form.motifs.$error) : null"
                                                                    placeholder=""
                                                            ></b-form-input>
                                                            <b-form-invalid-feedback v-if="errorshasField('object')">
                                                                {{ getErrorsField('object') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-if="$v.form.object.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>

                                                    </b-col>
                                                </b-row>

                                                <b-row>
                                                    <b-col md="12" sm="12">
                                                        <b-form-group
                                                                id="motif-group"
                                                                :label="$tc('message.description',1)"
                                                                label-for="motif">
                                                            <editor
                                                                    :api-key="tinyKey"
                                                                    id="motif"
                                                                    v-model="$v.form.description.$model"
                                                                    :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                                                    placeholder=""
                                                                    @focus="clearErrorField('description')"
                                                                    :init="{
                                                                        height: 200,
                                                                        menubar: false,
                                                                        plugins: plugins,
                                                                        toolbar:toolbar
                                                                    }"
                                                            >
                                                            </editor>
                                                            <b-form-invalid-feedback v-if="errorshasField('description')">
                                                                {{ getErrorsField('description') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-if="$v.form.description.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>

                                                    </b-col>
                                                </b-row>

                                                <!--<b-row>
                                                    <b-col md="12" sm="12">
                                                        <b-form-group
                                                                id="bindToPatientMedicalFolder-group"
                                                                :label="$t('message.bindToPatientMedicalFolder')"
                                                                label-for="bindToPatientMedicalFolder">
                                                            <b-form-radio
                                                                    v-model="$v.form.bindToPatientMedicalFolder.$model"
                                                                    name="bindToPatientMedicalFolder"
                                                                    value="bind"
                                                                    :inline="true"
                                                            >
                                                                {{ $t('message.yes') }}
                                                            </b-form-radio>
                                                            <b-form-radio
                                                                    v-model="$v.form.bindToPatientMedicalFolder.$model"
                                                                    name="bindToPatientMedicalFolder"
                                                                    value="notBind"
                                                                    :inline="true"
                                                            >
                                                                {{ $t('message.no') }}
                                                            </b-form-radio>
                                                            <b-form-invalid-feedback v-if="errorshasField('bindToPatientMedicalFolder')">
                                                                {{ getErrorsField('bindToPatientMedicalFolder') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-if="$v.form.bindToPatientMedicalFolder.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>

                                                    </b-col>
                                                </b-row>-->

                                                <b-row>
                                                    <b-col md="12" sm="12">
                                                        <b-form-group
                                                            id="specialties-group"
                                                            :label="$tc('message.doctorsAdvice',2)"
                                                            label-for="doctors">
                                                            <select
                                                                id="doctors"
                                                                v-model="$v.form.doctors.$model"
                                                                @change="clearErrorField('doctors')"
                                                                class="form-control is-invalid retirerBordure"
                                                                required
                                                                multiple>
                                                                <option data-placeholder="true"></option>
                                                                <option v-for="(item, key) in mContributors" :selected="form.doctors.includes(item)" :key="key+'mContributors'" :value="item.id">
                                                                    {{ item.nom }}
                                                                </option>
                                                            </select>
                                                            <span v-if="errorshasField('doctors')" style="color:red">
                                                                {{getErrorsField('doctors')}}
                                                            </span>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>

                                                <b-row class="mt-3">
                                                    <b-col md="12" sm="12">
                                                        <b-form-group
                                                                id="patient-group"
                                                                :label="$t('message.select')+' '+$t('message.emergencyCode')"
                                                                label-for="emergencyCode">
                                                            <!-- Options -->
                                                            <select id="emergencyCode" v-model="$v.form.emergencyCode.$model" required
                                                                    class="form-control is-invalid border-light retirerBordure">
                                                                <option v-for="(item, key) in emergencyCodeList" :selected="item == form.emergencyCode" :value="item" :key="key+'emergencyCodeList'">
                                                                    {{ item }}
                                                                </option>
                                                            </select>

                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>

                                                <!--<b-row class="mt-3">
                                                    <b-col md="12" sm="12">
                                                        <span class="obligatoire">*</span>

                                                        <b-form-group
                                                                id="responsable-group"
                                                                :label="$t('message.select')+' '+$t('message.manager')"
                                                                label-for="responsable">
                                                            &lt;!&ndash; Options &ndash;&gt;
                                                            <select id="responsable" v-model="$v.form.responsable.$model" required
                                                                    class="form-control is-invalid border-light"
                                                            >
                                                                <option v-for="item in mContributors" :value="item.id" :key="item.id">
                                                                    {{ item.nom }}
                                                                </option>
                                                            </select>

                                                            <b-form-invalid-feedback v-if="errorshasField('responsable')">
                                                                {{ getErrorsField('responsable') }}
                                                            </b-form-invalid-feedback>

                                                            <b-form-invalid-feedback v-if="$v.form.responsable.$error">
                                                                {{ $t('message.requiredField') }}
                                                            </b-form-invalid-feedback>

                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>-->

                                                <b-row>
                                                    <b-col md="12" sm="12" class="text-center mb-3">
                                                        <b-button @click="onSubmit" variant="primary">
                                                            {{ $t('message.save') }}
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-container>
                                        </b-form>
                                    </section>
                                </b-container>
                            </div>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
	import * as _ from "lodash";
	import {mapGetters} from "vuex";
	import SlimSelect from "slim-select";
	import {required} from 'vuelidate/lib/validators';
	import Editor from '@tinymce/tinymce-vue';
	import AppConfig from "../../constants/AppConfig";

    export default {
        name: "EditMedicalAdvice",

		components: {
			editor: Editor
		},

        computed: {
            ...mapGetters([
				"practitioners",
				"controlDoctors",
                "patients",
                "medicalAdvice",
            ]),

			mPatients: function() {
				let pArray = [];

				_.forEach(this.patients, function(patient) {
					if (typeof patient.user == 'object' && (patient.user != null) && patient.user.isMedicasure){
						let user = patient.user;
						if (typeof patient.dossier == "object" && patient.dossier !=null){
							let dossier  = patient.dossier;
                            //console.log("dossier ", dossier)
							let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
							prenom =  prenom.toLowerCase();
							let text = (user.nom).toUpperCase()+" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
							pArray.push({text: text, value: patient.dossier.id });
						}
					}
				});

				return pArray;
			},

			mPractitioners: function() {
				let pArray = [];

				_.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
					let p = {};
					// if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure == '1'){
					if((typeof practitioner.user == 'object') && (practitioner.user != null) && practitioner.user.isMedicasure){
						//console.log('practitioner.user.isMedicasure => ', practitioner.user.isMedicasure);
						let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
						prenom =  prenom.toLowerCase();
						p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						p.id = practitioner.user.id;
						if (p.nom.length >0){
							pArray.push(p);
						}
					}

				});

				return pArray;
			},

			mDoctors: function() {
				let dArray = [];

				_.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
					let d = {};
					// if((typeof doctor.user == 'object') && (!_.isNull(doctor.user)) && doctor.user.isMedicasure == '1'){
					if((typeof doctor.user == 'object') && (doctor.user != null) && doctor.user.isMedicasure){
						let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
						prenom =  prenom.toLowerCase();
						d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
						d.id = doctor.user.id;

						if (d.nom.length >0){
							dArray.push(d);
						}
					}

				});

				return dArray;
			},

			mContributors:function () {
				let cArray = [];
				return cArray.concat(this.mDoctors,this.mPractitioners);
			}
        },

        data() {
            return {
				form:{
					patient_id: '',
					bindToPatientMedicalFolder: '',
					description: '',
					emergencyCode: '',
					object: '',
					doctors: [],

					// this field is hidden and its value if filled automatically
					slug: ''
				},
				emergencyCodeList: [
					'Normal',
					'Urgent',
					'Ultra urgent',
				],
				offset: 0,
				limit: -1,
				medicalAdviceSlug: this.$route.params.medicalAdviceSlug,
				tinyKey: AppConfig.tinyMceKey,
				plugins : [
					'advlist autolink lists image charmap',
					'searchreplace visualblocks code fullscreen',
					'print preview anchor insertdatetime media',
					'paste code help wordcount table'
				],
				toolbar : 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
            };
        },
        watch: {
			medicalAdvice: function (newMedicalAdvice, oldMedicalAdvice) {
				// console.log('newMedicalAdvice => ', newMedicalAdvice);
				// console.log('medicalAdvice', this.medicalAdvice);
                
				this.form.patient_id = this.medicalAdvice.dossier_medical_id;
				this.form.bindToPatientMedicalFolder = this.medicalAdvice.creer_lien ? 'bind' : 'notBind';

				this.form.description = this.medicalAdvice.description;
				this.form.object = this.medicalAdvice.objet;
				this.form.doctors = this.medicalAdvice.medecin_avis.map(m => m.medecin_id);
                this.form.emergencyCode = this.medicalAdvice.code_urgence
			},
        },
        methods: {

			getMedicalAdvice() {
				const args = {
					avis: this.medicalAdviceSlug
				};
				const errorMessages = {
					generic: this.$i18n.t('message.genericError'),
					error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
				};

				this.$store.dispatch('getMedicalAdvice', { args, errorMessages });
			},

			onSubmit() {
            	event.preventDefault();
            	// console.log('form => ', this.form);
				event.preventDefault();
				this.$v.$touch();

				if (!this.$v.$invalid ) {
					const args = {};
					args.dossier_medical_id = this.form.patient_id;
					args.objet = this.form.object;
					args.description = this.form.description;
					args.creer_lien = '1';

					if (this.form.emergencyCode && this.form.emergencyCode.length > 0) {
						args.code_urgence = this.form.emergencyCode;
					} else args.code_urgence = this.emergencyCodeList[0];

					args.medecins = this.form.doctors;

					const successMessage = this.$i18n.t('message.medicalAdviceUpdated');
					const errorMessages = {
						generic: this.$i18n.t('message.genericError'),
						error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
					};

					const payload = { args, errorMessages, slug: this.medicalAdviceSlug, successMessage };

					this.$store.dispatch('updateMedicalAdvice', payload).then(() => {

					});
				}
            },

			getPatients: function() {
				this.$store.dispatch('getPatients', { args: {} });
			},

			getDoctors() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getControlDoctors', { args : args });
			},

			getPractitioners() {
				let args = {
					offset: this.offset,
					limit: this.limit
				};

				this.$store.dispatch('getPractitioners', { args : args });
			},

			errorshasField(field) {
				return this.errors ? this.errors.hasOwnProperty(field) : false;
			},

			clearErrorField(field) {
				this.$store.dispatch('clearErrorField', {field});

				this.errorshasField(field);
			}
        },
		validations() {
			return {
				form: {
					patient_id:{
						required
					},

					bindToPatientMedicalFolder:{

					},

					emergencyCode:{

					},

					description:{
						required
					},

					object:{
						required
					},

					doctors:{
						// required
					}
				}
			}
		},
        mounted() {
            this.getMedicalAdvice();

            this.getPatients();

			// Fetch control doctor list
			this.getDoctors();

			// Fetch practitioner list
			this.getPractitioners();

			new SlimSelect({
				select: '#patient',
				// placeholder: 'Select doctors',
				limit: 1
			});

			new SlimSelect({
				select: '#doctors',
				placeholder: 'Select doctors',
				limit: 5
			});

			new SlimSelect({
				select: '#emergencyCode',
				// placeholder: 'Select doctors',
				limit: 1
			});
        }
    }
</script>





<style scoped lang="scss">

</style>
